// extracted by mini-css-extract-plugin
export default {"card":"EataSection_card__PElQ5"};